import React, { ReactElement, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import styles from './CopyBlock.module.scss'

import { Copy as CopyIcon } from '../../../icons'
import CustomButton from '../../buttons/CustomButton'

interface ICopyBlockProps {
  text: string
  className?: string
  disableBtn?: boolean
  slot?: string | ReactElement
  onSlotBtnClick?: () => void
}

const CopyBlock: React.FC<ICopyBlockProps> = (props) => {
  const { text, onSlotBtnClick, className, disableBtn } = props

  const [copiedVar, setCopiedVar] = useState<boolean | null>(null)
  const [gettingNewIpLoaderStatus, toggleGettingNewIpLoader] = useState(false)

  const handleSlotBtnClick = (e: any) => {
    e.stopPropagation()

    if (!!onSlotBtnClick) {
      toggleGettingNewIpLoader(true)
      setTimeout(() => toggleGettingNewIpLoader(false), 300)

      onSlotBtnClick()
    }
  }

  return (
    <div
      className={`
        ${styles.container}
        ${className || ''}
      `}
    >
      <CopyToClipboard
        text={text}
        onCopy={() => {
          setCopiedVar(true)
          setTimeout(() => setCopiedVar(false), 300)
        }}
      >
        <div className={styles.content}>
          <div className={styles.text}>{text}</div>

          <div className={styles.controls}>
            <div className={styles.iconWrapper}>
              <CopyIcon />

              <span
                className={`
                  ${styles.tip}
                  ${copiedVar ? styles.active : ''}
                `}
              >
                Copied
              </span>
            </div>

            <CustomButton
              color={'outline'}
              onClick={handleSlotBtnClick}
              loading={gettingNewIpLoaderStatus}
              disabled={disableBtn}
            >
              Get new IP
            </CustomButton>
          </div>
        </div>
      </CopyToClipboard>
    </div>
  )
}

export default CopyBlock
